import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs, Base_url_api_live , Base_url_imggg } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";
import { FaTrash, FaTimes, FaUpload, FaPlus } from "react-icons/fa"; 

const initialData = {
  pro: "Sameday", 
  proThree: "",
  profive: "", 
  prouser : "",
  prohead : "" ,
  pronoti : "" ,
  proremove : ""
};

const initialDataedu = {
  pro: "Sameday", 
  proThree: "",
  profive: "", 
  prouser : "",
  prohead : "" ,
  pronoti : "",
  proremove : ""
};

let User_kyc_not_verified = () => {
  let [datat, setData] = useState();
  const [ggs, setGgs] = useState([]);

  let [one, setOne] = useState();
  let [two, setTwo] = useState();
  let [three, setThree] = useState(true);

  let [five, setFive] = useState();
  let [six, setSix] = useState();
  let [seven, setSeven] = useState(true);

  let [eight, setEight] = useState();
  let [nine, setNine] = useState();
  let [ten, setTen] = useState(true);


  let [four, setFour] = useState();

  let [utilityflow, setUtilityflow] = useState(true);

  let [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  let [text, setText] = useState("");

  let [eduval, setEduval] = useState()
  let [utival, setUti] = useState()
  let [finedata, setFinedata] = useState()

  const [counts, setCountdata] = useState();
  let [count, setCount] = useState();

  const [formBlocks, setFormBlocks] = useState([initialData]);

  useEffect(()=>{

    Start()

  },[])


  let Start = async () =>{
    try {
      let token = await localStorage.getItem("token");

      let pp = { token };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/user_kyc_not_verified",
        data: { limit : 10 , page : 0 }, 
      })
        .then((dat) => { 
          setData(dat.data.data)
          setCount(dat.data.totalCount);
 
          console.log( dat.data, "Jsson ddddddddddddddddddddddddddddddddddddddddddddddddddddddddd");

        })
        .catch((ee) => { });
    } catch (err) { }
  } 

  const handlePageClick = async (event) => {

    console.log(event.selected , 'kkkkkkkkkkkkkkkkkkkk');

     setCountdata(event.selected);

     try {
      let token = await localStorage.getItem("token");

      let pp = { token };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/user_kyc_not_verified",
        data: { limit : 10 , page : event.selected  }, 
      })
        .then((dat) => {  
          console.log( dat.data, "Jsson ddddddddddddddddddddddddddddddddddddddddddddddddddddddddd");
          setData(dat.data.data) 

        })
        .catch((ee) => { });
    } catch (err) { }
  };

  function convertToIndianDate(utcDateString) {
    const date = new Date(utcDateString);

    // Convert to IST (UTC+5:30)
    const istOffset = 5.5 * 60; // minutes
    const istDate = new Date(date.getTime() + istOffset * 60 * 1000);

    const day = String(istDate.getDate()).padStart(2, '0');
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const year = istDate.getFullYear();

    return `${day}-${month}-${year}`;
  }


  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{
            overflowY: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
          }}
        > 
        <p className="mt-2" style={{ fontWeight: "bold", fontSize: "20px" }} >User Kyc Not Verified</p>

        <div style={{ marginTop : 20 }} >
          <div className="row">

            <div className="row mb-5 mt-3" style={{ border: '1px solid rgb(216, 216, 216)' , fontSize : 20 , fontWeight : '700'  }}  >
                <div className="col-2" >
                  <p>Name</p>
                </div>
                <div className="col-2" >
                  <p>Phone No</p>
                </div>
                <div className="col-2" >
                  <p>Aadhar Name</p>
                </div>
                <div className="col-2" >
                  <p>email</p>
                </div>
                <div className="col-2" >
                  <p>Date</p>
                </div>

              </div>




              <div className="position-relative" style={{ width: '100%' }}>

                {
                  datat?.map((re, index) => {
                    return (
                      <div onClick={()=>{ navigate("/useralldetail", { state: re?.otherValue });  }} className="row" style={{ border: '1px solid rgb(216, 216, 216)' }}  >
                        <div className="col-2" >
                          <p>{re?.otherValue?.name}</p>
                        </div>
                        <div className="col-2" >
                          <p>{re?.otherValue?.phoneno}</p>
                        </div>
                        <div className="col-2" >
                          <p>{re?.name}</p>
                        </div>
                        <div className="col-2" >
                          <p>{re?.otherValue?.email}</p>
                        </div>
                        <div className="col-2" >
                          <p>{convertToIndianDate(re?.createdAt)}</p>
                        </div>
                      </div>
                    );
                  })
                }
 

              </div>


            <div className="mt-3" > 
              <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={count / 10}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                containerClassName="pagination justify-content-center"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                forcePage={counts}
              />
            </div>
            
          </div>
        </div>

        </div>
      </div>
    </div>
  );
};

export default User_kyc_not_verified;
